import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { TPropertyStatus } from '@shared/models/properties';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';
import { setUnsavedStatusFiltersAction } from '@state/filters/filters.actions';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-status',
  templateUrl: './filter-v2-status.component.html',
  styleUrls: [
    './filter-v2-status.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2StatusComponent implements OnInit {
  @Input() mobile = false;
  @Output() applyFilters = new EventEmitter();
  @ViewChild('trigger') menuTrigger!: MatMenuTrigger;

  protected isOpen = false;
  protected checkedCount = 0;
  protected allSelected = false;

  protected statuses: TPropertyStatus[] = ['OPEN', 'PENDING', 'SOLD'];
  public checkedStatuses: { [key: string]: boolean } = this.statuses.reduce(
    (acc, status) => ({
      ...acc,
      [status]: false,
    }),
    {}
  );

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    // for loading the first time
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.status && filters.status.in) {
          if (filters.status.in.length === this.statuses.length) {
            this.allSelected = true;
          }
          this.checkedStatuses = this.statuses.reduce(
            (acc, status) => ({
              ...acc,
              [status]: filters?.status?.in?.includes(status),
            }),
            {}
          );
          this.onChangeStatuses();
        }
      });

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (!filters?.status?.in && this.checkedCount > 0) {
          this.checkedCount = 0;
          this.allSelected = false;
          this.checkedStatuses = this.statuses.reduce(
            (acc, status) => ({
              ...acc,
              [status]: false,
            }),
            {}
          );
        }
      });
  }

  onChangeStatuses() {
    const statusesLength = Object.values(this.checkedStatuses).filter(
      (status) => status
    ).length;
    this.checkedCount = statusesLength;
    if (statusesLength === this.statuses.length) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
    if (statusesLength) {
      this.store.dispatch(
        setUnsavedStatusFiltersAction({
          in: [
            ...Object.keys(this.checkedStatuses).filter(
              (key: string) => this.checkedStatuses[key]
            ),
          ] as TPropertyStatus[],
        })
      );
    } else {
      this.store.dispatch(setUnsavedStatusFiltersAction({}));
    }
    if (!this.mobile) this.applyFilters.emit();
  }

  toggleAllSelection() {
    this.allSelected = !this.allSelected;
    this.checkedStatuses = this.statuses.reduce(
      (acc, status) => ({
        ...acc,
        [status]: this.allSelected,
      }),
      {}
    );
    this.onChangeStatuses();
  }

  resetStatuses() {
    this.checkedStatuses = this.statuses.reduce(
      (acc, status) => ({
        ...acc,
        [status]: false,
      }),
      {}
    );
    this.onChangeStatuses();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.status && filters.status.in) {
          if (filters.status.in.length === this.statuses.length) {
            this.allSelected = true;
          }
          this.checkedStatuses = this.statuses.reduce(
            (acc, status) => ({
              ...acc,
              [status]: filters?.status?.in?.includes(status),
            }),
            {}
          );
          this.onChangeStatuses();
        }
      });
  }
}
